import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Label,
  Input as IMP,
  Form,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button
} from 'reactstrap';
// import { Button } from '@material-ui/core';
import { Device } from '@twilio/voice-sdk';
import { connect } from 'react-redux';
import { gettoken } from '../../../Redux/Actions/Twilio';
import PropTypes from 'prop-types';
import Loader from '../../../components/common/Loader';
import 'react-phone-input-2/lib/style.css';
import UserForm from './Form';
import './sigCanvas.css';
import Popup from 'reactjs-popup';
import GetCOmpany from '../../../components/GetCompany/getCompany';
import { useHistory } from 'react-router-dom';
import { getuserStatus, postuserStatus, savenotes, getVoices } from '../../../Redux/Actions/USER/user';
import Switch from '@material-ui/core/Switch';
import {socket} from '../Main/socket'
import { toast } from 'react-toastify';
import NewDialer from './newdialer';

import Background from '../../../components/common/Background';
import corner1 from '../../../assets/img/illustrations/corner-1.png';
import corner2 from '../../../assets/img/illustrations/corner-2.png';
import corner3 from '../../../assets/img/illustrations/corner-3.png';
import AddProspect1 from '../Prospects/addProspect1';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import UserVoice from '../User/Voice';
import PhoneInput from 'react-phone-input-2';
import Dialmonitor from '../User/callmonitor';
import { sendmessage } from '../../../Redux/Actions/Twilio';
import Newmultiline from '../Multiline/newmultilineCall';
import { callmonitor } from '../../../Redux/Actions/USER/user';
import Tooltipbutton from '../../../components/Tooltip/Tooltip';
import FormGroup from 'reactstrap/lib/FormGroup';
import { checkbal } from '../../../Redux/Actions/Payment';
import { openDialog } from '../../../Redux/Actions/Twilio';
// Import the twilioErrorDetails.json file
import twilioErrorDetails from './twilioErrorDetails.json';  // Adjust path if needed
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
// import Switch from '@material-ui/core/Switch';
const axios = require('axios');
const Dial = ({
  sendmessage,
  toggle,
  savenotes,
  Token,
  gettoken,
  numbers,
  getuserStatus,
  location,
  postuserStatus,
  callmonitor,
  getVoices,
  isPaid,
  count,
  openDialog
}) => {
  const [num, setnum] = useState('');
  const [dis, setdis] = useState(true);
  const [from, setfrom] = useState(null);
  const [inbound, setinbound] = useState(false); //
  const [seconds, setSeconds] = useState(0);
  const [timer, setTimer] = useState(false);
  const [checked, setchecked] = useState(false);
  const [connection, setConnection] = useState(null);
  const [callconnect, setcallconnect] = useState(false);
  const [permissionStatus, setpermissionStatus] = useState('');
  const [allowdigit, setallowdigit] = useState(false);
  const [formshow, setshowform] = useState(false);
  const [search, setSearch] = useState('');
  const [details, setdetails] = useState(null);
  const [cmpname, setcmpname] = useState(null);
  const [modal, setmodal] = useState(false);
  const [notetoggle, setnotetoggle] = useState(false);
  const [body, setbod] = useState('');
  const [bodyerr, setbodyerr] = useState(false);
  const [err, setErr] = useState(false);
  const [showprospet, setshowprospet] = useState(false);
  const [open, setopen] = useState(false);
  const [dil, setdil] = useState(true); //
  const [errorexist, setErrorExist] = useState(false);
  const [note, setnotes] = React.useState('');
  const [isOpenDial, setclosedialer] = useState(false);
  const [mic, setmicrophone] = useState(false);
  const [conn, setconn] = useState(null);
  const [inboundcheck, setinboundcheck] = useState(false);
  const [outboundcheck, setoutboundcheck] = useState(false);
  const [device, setDevice] = useState();
 
  const handleInboundChange = () => {
    if (!inboundcheck && !outboundcheck) {
      setinboundcheck(true);
    } else {
      setinboundcheck(!inboundcheck);
      setoutboundcheck(!outboundcheck);
    }
  };
  const handleOutboundChange = () => {
    if (!inboundcheck && !outboundcheck) {
      setoutboundcheck(true);
    } else {
      setoutboundcheck(!outboundcheck);
      setinboundcheck(!inboundcheck);
    }
  };
  const history = useHistory();
  const formtoogleToggle = () => {
    setshowform(!formshow);
  };
  const Toggle = () => {
    setmodal(!Modal);
  };
  const closedialer = () => {
    setclosedialer(!isOpenDial);
  };
  const NoteToggle = () => {
    setnotetoggle(!notetoggle);
  };

  useEffect(() => {
      // Ensure connection is established first
      socket.on('connect', () => {
        console.log('Socket connected in User Chat message!');
      });
  
      socket.on('undeliveredMessage', async (data) => {
        console.log("exist From Chat=================================", data);
  
        if (data.status === 'undelivered') {
          // Fetch the error details from the JSON file based on the ErrorCode
          const errorCodeNum = Number(data.ErrorCode);
          const error = twilioErrorDetails.find(item => item.code === errorCodeNum);
  
          if (errorCodeNum === 30034) {
  
            // If the ErrorCode is 30034, show a custom message with registration link
            toast.error(
              <div>
                Your recent message could not be delivered because your number {data.from} is not registered under A2P 10DLC. 
                Please complete your registration <a href="https://call.mergeasy.com/hub" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>Here</a>.
              </div>
            );
  
          } else {
            // For other error codes, display a generic message
            toast.error(`${error?.message || error?.description || 'Failed to send message!'}`);
          }
        }
      });
  
      // Cleanup on unmount or disconnection
      return () => {
        socket.off('undeliveredMessage'); // Unsubscribe to avoid memory leaks
        socket.off('connect');
      };
    }, []);

  const submitmsg = () => {
    if (num === '' || num.length > 13 || from === '') {
      setErr(true);
    } else {
      setErr(false);
      sendmessage(num, body, from);
      setnum('');
      setbod('');
      setmodal(!modal);
    }
  };

  const bodydata = e => {
    if (e.target.value.length > 1590) {
      setbodyerr(true);
      toast.error('Message Body length cannot be greater than 1590');
    } else {
      setbod(e.target.value);
      setbodyerr(false);
    }
  };

  if (location.state != undefined && location.state.inbound && !inbound) {
    console.log('location.state', location.state);
    history.replace('/call');
    setdetails(location.state.detailss);
    setcmpname(location.state.cmpnamee);
    setdil(false);
    setinbound(true);
    setclosedialer(true);
    setTimer(true);
  }


  const handleChange = event => {
    postuserStatus(event.target.checked);
    setchecked(event.target.checked);
  };

  useEffect(() => {
    const a = numbers.map(item => {
      if (item.activate) {
        return item.number;
      }
    });
    setfrom(a[0]);
  }, [numbers]);
  useEffect(() => {
    if (from == 'buynumber') {
      {
        history.push('/buynumber');
      }
    }
  }, [from]);

  const [handle, setHandle] = useState(null);
  useEffect(() => {
    getuserStatus();
    if (toggle != checked) {
      setchecked(toggle);
    }
    if (timer) {
      const interval = setInterval(() => {
        setSeconds(seconds => seconds + 1);
      }, 1000);
      setHandle(interval);
    }
    const param = new URLSearchParams(window.location.search);
    const f = param.get('from');

    const g = param.get('to');
    localStorage.removeItem('redirecturl');

    setnum(g);

    if (Token === '') {
      gettoken();
    } else {
      fetchdata();
    }
    async function fetchdata() {
      var device1 = new Device(Token);
      setDevice(device1);
      console.log('device >>>>>>>>>>', device);
     
    }
  }, [Token, gettoken, timer, getuserStatus]);

  useEffect(() => {
    return () => {
      if (handle) {
        clearInterval(handle);
      }
    };
  }, [handle]);
  const backtodialer = () => {
    setshowform(false);
    setclosedialer(true);
  };
  const changestatus = () => {
    setcallconnect(false);
  };


  useEffect(() => {
    if (conn != null) {
      conn.mute(mic);
    }
  }, [mic]);

 
  const submit = async numb => {
 
    const res = await axios({
      method: 'POST',
      url: process.env.REACT_APP_PORT + `/api/payment/checkbal`,
      headers: {
        'x-auth-token': localStorage.getItem('token')
      }
    });
    setErrorExist(false);
    if (res.data.data) {
  
      await navigator.permissions.query({ name: 'microphone' }).then(async function(permissionstatus) {
  

        // debugger
        if (permissionstatus.state === 'granted') {
          if (!from || numb == null || from == '+null' || numb.length === 0) {
            toast.error('Please select company and a from number');
          } else if (numb.length > 13) {
            toast.error('Enter a Valid Number');
          } else {
            const data = {
              params: {
                To: numb,
                From: from,
                FromNum: from
              }
            };
            console.log('Device.connect >> data', data);
            let url = process.env.REACT_APP_PORT + `/api/logdevice`;
            var data1 = JSON.stringify({
              Device: 'Browser'
            });

            var config = {
              method: 'post',
              url: url,
              headers: {
                'Content-Type': 'application/json'
              },
              data: data1
            };

            axios(config)
              .then(function(response) {
                console.log(JSON.stringify(response.data));
              })
              .catch(function(error) {
                console.log(error);
              });
            console.log('device.connect', device, 'data', data, 'details', details, 'cmpname', cmpname);
            openDialog(data, Token);
       
          }
        } else {
          toast.error('Micro-Phone is disabled please enabled it');
        }
      });
    } else {
      toast.error('Please check Funds');
    }
  };
  const stateChanger = title => {
    setclosedialer(title);
  };
  const stateChanger1 = title => {
    setshowprospet(title);
  };
  const disconnect = () => {
    console.log('Home.js connection>>', connection);
    console.log('Inside Before Home.js >> disconnect>> device >>', device);
    // Device.disconnectAll();
    device.disconnectAll();
    console.log('Inside Home.js >> disconnect>> device >>', device);
    if (connection) {
      connection.disconnect();
    }
    setallowdigit(false);
    setdil(true);

    setclosedialer(false);
  };
  //switch logic
  const [state, setState] = useState({
    checkedB: false
  });
  const handleChangeSwitch = event => {
    if (event.target.checked) {
      window.location.href = '/call/multilinedialer';
    }
  };

  const ref = useRef();
  const handelOpen = () => {   
    
    console.log('===============inside home handelOpen===============');


    setshowform(false);
    setclosedialer(true);
  };


  //GeoCallerIdCode
  async function geoCallerIDNumber(value, code) {
    if (value && code.dialCode) {
      console.log('value.toString().length=', value.toString().length);
      var countryCode = code.dialCode;
      console.log('countryCode=', countryCode);
      var codeLength = code.dialCode.toString().length;
      console.log('codeLength=', codeLength);
      var areaCode = '';
      console.log('value.toString().length=', value.toString().length);
      if (value.toString().length > 7) {
        areaCode = value.toString().substring(codeLength, codeLength + 3);

        const getAreaOrCountryNumberGeoCallerID = await axios({
          method: 'get',
          url:
            process.env.REACT_APP_PORT +
            `/api/me/getAreaOrCountryNumberGeoCallerID?areaCode=${areaCode}&countryCode=${countryCode}`,
          headers: {
            'x-auth-token': localStorage.getItem('token')
          }
        });
console.log("getAreaOrCountryNumberGeoCallerID====================",getAreaOrCountryNumberGeoCallerID)
        var areaNumber = getAreaOrCountryNumberGeoCallerID.data.data.areaNumber;
        var countryNumber = getAreaOrCountryNumberGeoCallerID.data.data.countryNumber;
        var defaultNumber = getAreaOrCountryNumberGeoCallerID.data.data.defaultNumber;
        var geocallerid = getAreaOrCountryNumberGeoCallerID.data.data.geocallerid;

        console.log('areaNumber=', areaNumber,'countryNumber=', countryNumber,'defaultNumber=', defaultNumber)
        if (geocallerid == true && areaNumber != '') {
          console.log('areaNumber=', areaNumber);
          setfrom(areaNumber);
        } else if (geocallerid == true && countryNumber != '') {
          console.log('countryNumber=', countryNumber);
          setfrom(countryNumber);
        } else if (geocallerid == true && defaultNumber != '') {
          console.log('defaultNumber=', defaultNumber);
          setfrom(defaultNumber);
        } else {
          console.log('nothing to do');
        }
      }
    }
  }



  return (
    <div>
      {open ? (
        <Button
   
          style={{
            backgroundColor: '#0bf957',
            position: 'fixed',
            top: '15vh',
            right: '8vw',
            zIndex: 1000,
            borderRadius: '50%', // Ensures it stays circular
            width: '4.25vw', // Reduced size to 30% of previous size
            height: '4.25vw', // Same as width to maintain circle shape
            padding: '0', // Remove padding to maintain circular size
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0px 0px 12px 4px rgba(0,255,0,0.5)',
            transition: 'transform 0.2s ease-in-out',
          }}
       
          onClick={handelOpen}
        >
          <FontAwesomeIcon icon={faPhoneAlt} color="white" size="lg" />

        </Button>
      ) : null}
      {state.checkedB === false ? (
        <>
        {/*  <Row>
        <Col xs={12} className="col-xxl-8 pr-xl-2 mb-3"> */}
            <Card>
              <Background image={corner1} className="bg-card" />
              <Row className="mb-2">
                <Col sm={{ size: 5 }} style={{ marginLeft: '24px' }}>
                  <Label>Select Company</Label>

                  <GetCOmpany />
                </Col>

                <Col sm={{ size: 5, offset: 1 }}>
                  <Label>From Number</Label>
                  

                  <IMP
  style={{ fontSize: '0.95em' }}
  type="select"
  id="exampleSelect"
  bsSize="sm"
  onChange={e => setfrom(e.target.value)}
  name="from"
>
  {numbers !== undefined &&
    numbers &&
    numbers.length > 0 &&
    numbers.map((item, index) => {
      if (item.activate) {
        return (
          <option
            key={item._id || index}
            value={item.number}
            selected={index === 0 && item.activate}
          >
            {item.name ? item.name : item.number}
          </option>
        );
      }
      return null;
    })}

  {/* If no number is active, show fallback Buy Number */}
  {numbers && numbers.length > 0 && !numbers.some(num => num.activate) && (
    <option value="buynumber">Buy Number</option>
  )}

  {/* If numbers is empty string */}
  {numbers === '' && (
    <>
      <option value="">Select Number</option>
      <option value="buynumber">Buy Number</option>
    </>
  )}
</IMP>

                  {numbers != '' && (
                    <small>{from && from != '+null' && from != null && from != '' && `Caller id will be ${from}`}</small>
                  )}
                </Col>
              </Row>
            </Card>
          {/* </Col>
        </Row> */}
        </>
      ) : null}
      {state.checkedB === false ? (
        <Row className="mt-3">
          <Col lg={6} className="pr-lg-2 mb-3 mb-lg-0">
            {dil ? (
              <div ref={ref}>
                <Card>
                  <Background image={corner3} className="bg-card" style={{ zIndex: 1 }} />
                  <CardBody style={{ zIndex: 10 }}>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <Tooltipbutton title="Dial single line at a time">
                        <span style={{ fontWeight: 500, marginRight: '30px', fontSize: '16px', paddingTop: '5px' }}>
                          Dialer
                        </span>
                      </Tooltipbutton>
                      <Switch
                        checked={state.checkedB}
                        onChange={handleChangeSwitch}
                                                    style={{color:'#03A9D6'}}
color="primary"
                        name="checkedB"
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                      />
                      <Tooltipbutton title="Dials multiple line at a time">
                        <span style={{ fontWeight: 500, marginLeft: '30px', fontSize: '16px', paddingTop: '5px' }}>
                          Multidialer
                        </span>
                      </Tooltipbutton>
                    </div>
                  </CardBody>
                </Card>

 

                <Card className="mt-2">
  <CardBody>
    <Row className="justify-content-center">
      <Col sm="8" className="text-center">
        <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#55A5D4' }}>Make a call</p>
      </Col>
    </Row>
  

<Row style={{ display: "flex", justifyContent: "center" }}>
  <div
    style={{
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <PhoneInput
      onChange={async (value, country, e, formattedValue) => {
        geoCallerIDNumber(value, country);
        setnum(value);
      }}
      value={num}
    />
  </div>
</Row>
    <Row className="justify-content-center mt-3">
      <Col sm="8" className="text-center">
        <Button
          onClick={() => submit(num)}
          disabled={bodyerr}
          color="primary"
          size="sm"
          className="mr-2"
        >
          <i className="fas fa-phone-alt" />
          &nbsp;&nbsp;Call
        </Button>
        <Button
          disabled={bodyerr}
          color="primary"
          size="sm"
          className="mr-2"
          onClick={() => setmodal(!modal)}
        >
          Message &nbsp;&nbsp;
          <i className="far fa-envelope" />
        </Button>
      </Col>
    </Row>
    <Row className="justify-content-center">
      <Col xs="12" className="text-center pt-2">
        <small id="emailHelp" className="form-text text-muted">
          Your call will be placed using the browserphone.
        </small>
      </Col>
    </Row>
  </CardBody>
</Card>

              </div>
            ) : (
              <div ref={ref}>
           
                <Row>
                  {Token !== '' && inbound ? (
                    <div>
                      <Col xs="12">
                      </Col>
                      <Col xs="12" className="mt-2 ">
                        <Card>
                          <CardBody className="p-2">
                            <Label>Inbound Call {connection != null ? connection.parameters.From : ''}</Label>
                            <Row>
                              <Col xs={12}>{timer ? <div>{`${seconds} seconds`}</div> : null}</Col>
                            </Row>
                            <Row>
                              <Col xs="8">
                                <IMP type="text" onChange={e => setnotes(e.target.value)} placeholder="add note" />
                              </Col>
                              <Col xs="4">
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={() => {
                                    savenotes(note, connection.parameters.From, connection.parameters.CallSid);
                                  }}
                                >
                                  Submit
                                </Button>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    </div>
                  ) : null}

               
                </Row>
              </div>
            )}
          </Col>
          <Col lg={dil ? 6 : 12} className="pr-lg-2 mb-3 mb-lg-0">
            <Card>
              <Background image={corner3} className="bg-card" />
              <CardBody>
                <Label style={{ marginRight: '30px', fontSize: '16px', paddingTop: '5px' }}>Active Calls</Label>
         
                {details != null && details == 'Not Found' && showprospet && (
                  <div style={{ position: 'fixed', top: '20vh', right: '25vw', zIndex: 1 }}>
                    <AddProspect1 stateChanger={stateChanger} stateChanger1={stateChanger1} />
                  </div>
                )}
              </CardBody>
            </Card>
            <Card className="mt-2">
              <Dialmonitor />
            </Card>
          </Col>
      
        </Row>
      ) : (
        <Newmultiline handleswitch={handleChangeSwitch} />
      )}

      {/* {state.checkedB === false ? (
        <div style={{width:"100%"}}>
          {' '}
          <Row className="mt-3">
            <Col xs={12} className="col-xxl-8 pr-xl-2 mb-3">
              <Card>
                <Background image={corner2} className="bg-card" />
                
                <Row
  style={{
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    paddingTop: '1rem',
    paddingBottom: '0.25rem',
  }}
>
  <Col style={{ flex: '1 1 20%', minWidth: '150px' }}>
    <Label>Call logs</Label>
  </Col>

  <Col style={{ flex: '1 1 30%', minWidth: '250px' }}>
    <Form style={{ display: 'flex', justifyContent: 'space-around' }}>
      <FormGroup check>
        <Label check>
          <Input type="radio" name="radio1" onChange={() => handleInboundChange()} /> Inbound
        </Label>
      </FormGroup>
      <FormGroup check>
        <Label check>
          <Input type="radio" name="radio1" onChange={() => handleOutboundChange()} /> Outbound
        </Label>
      </FormGroup>
    </Form>
  </Col>

  <Col style={{ flex: '1 1 25%', minWidth: '200px' }}>
    <div className="search-box" style={{ position: 'relative',width:"90%" ,paddingBottom:'10px' }}>
      <Input
        type="search"
        placeholder="Search..."
        aria-label="Search"
        className="rounded-pill search-input"
        value={search}
        onChange={({ target }) => setSearch(target.value)}
      />
    </div>
  </Col>
</Row>

              </Card>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs={12} className="col-xxl-8 pr-xl-2 mb-3">
              <UserVoice search={search} outboundcheck={outboundcheck} inboundcheck={inboundcheck} />
            </Col>
          </Row>{' '}
        </div>
      ) : null} */}


      {state.checkedB === false ? (
  <div
    style={{
      width: '100%',
      maxWidth: '100%',
      padding: 0,
      margin: 0,
      display: 'block',
    }}
  >
    <Row
      className="mt-3"
      style={{
        width: '100%',
        margin: 0,
        padding: 0,
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Col
        xs={12}
        className="col-xxl-8 pr-xl-2 mb-3"
        style={{
          width: '100%',
          maxWidth: '100%',
          padding: 0,
          margin: 0,
          flex: '1 1 100%',
        }}
      >
        <Card
          style={{
            width: '100%',
            maxWidth: '100%',
            margin: 0,
            padding: 0,
            boxSizing: 'border-box',
          }}
        >
          <Background image={corner2} className="bg-card" />

          <Row
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'space-between',
              paddingLeft: '1rem',
              paddingRight: '1rem',
              paddingTop: '1rem',
              paddingBottom: '0.25rem',
              width: '100%',
              margin: 0,
              boxSizing: 'border-box',
            }}
          >
            <Col style={{ flex: '1 1 20%', minWidth: '150px' }}>
              <Label>Call logs</Label>
            </Col>

            <Col style={{ flex: '1 1 30%', minWidth: '250px' }}>
              <Form
                style={{
                  display: 'flex',
                  justifyContent: 'space-around',
                  width: '100%',
                }}
              >
                <FormGroup check>
                  <Label check>
                    <Input
                      type="radio"
                      name="radio1"
                      onChange={() => handleInboundChange()}
                    />{' '}
                    Inbound
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Label check>
                    <Input
                      type="radio"
                      name="radio1"
                      onChange={() => handleOutboundChange()}
                    />{' '}
                    Outbound
                  </Label>
                </FormGroup>
              </Form>
            </Col>

            <Col
              style={{
                flex: '1 1 25%',
                minWidth: '200px',
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <div
                className="search-box"
                style={{
                  position: 'relative',
                  width: '100%',
                  maxWidth: '350px',
                  paddingBottom: '10px',
                }}
              >
                <Input
                  type="search"
                  placeholder="Search..."
                  aria-label="Search"
                  className="rounded-pill search-input"
                  value={search}
                  onChange={({ target }) => setSearch(target.value)}
                  style={{ width: '100%' }}
                />
              </div>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>

    {/* <Row
      className="mt-2"
      style={{
        width: '100%',
        margin: 0,
        padding: 0,
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Col
        xs={12}
        className="col-xxl-8 pr-xl-2 mb-3"
        style={{ width: '100%', padding: 0, margin: 0 }}
      > */}
        <UserVoice
          search={search}
          outboundcheck={outboundcheck}
          inboundcheck={inboundcheck}
        />
      {/* </Col>
    </Row> */}
  </div>
) : null}


    
 
   
      {}
      {modal ? (
        <Modal isOpen toggle={Toggle}>
          <ModalBody>
            <Row>
                <Label style={{left:'0%'}}>To</Label>
                <PhoneInput onChange={phone => setnum(phone)} value={num} />
            </Row>
            <br></br>
            <Row>
              
                <Label style={{left:'0%'}}>Text</Label>
                <Input
                  style={{ fontSize: '0.95em' }}
                  placeholder="Enter your text here"
                  type="textarea"
                  onChange={bodydata}
                  name="body"
                  value={body}
                />
            
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={submitmsg}
              disabled={bodyerr}
              color="primary"
              variant="contained"
              size="sm"
              className="mr-2"
            >
              Send Message
            </Button>
          </ModalFooter>
        </Modal>
      ) : null}
      {notetoggle ? (
        <Modal isOpen toggle={NoteToggle}>
          <ModalBody>
            <Row>
              <Col md="12">
                <Label>Inbound Call {connection != null ? connection.parameters.From : ''}</Label>
              </Col>
            </Row>
            <Row>
              <Col md="12">{timer ? <div>{`${seconds} seconds`}</div> : null}</Col>
            </Row>
            <Row>
              <Col xs="12">
                <IMP type="text" onChange={e => setnotes(e.target.value)} placeholder="add note" />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                savenotes(note, connection.parameters.From, connection.parameters.CallSid);
                setnotetoggle(false);
              }}
            >
              Submit
            </Button>
          </ModalFooter>
        </Modal>
      ) : null}
    </div>
  );

 
};
Dial.propTypes = {
  gettoken: PropTypes.func.isRequired,
  Token: PropTypes.string.isRequired
};
const mapStateToProps = state => ({
  Token: state.Twilio.token,
  toggle: state.Twilio.toggle,
  numbers: state.Twilio.numbers,
  isPaid: state.auth.isPaid
});
export default connect(
  mapStateToProps,
  { sendmessage, gettoken, savenotes, getuserStatus, postuserStatus, callmonitor, getVoices, openDialog }
)(Dial);
